import angular from 'angular';

import component from './photoLightboxModal.component';

export default angular.module('app.shared.photoLightboxModal', [
    'cars.ui.angular'
])

.component('photoLightboxModal', component)

.name;
